import handleLoad from './handleLoad';

/**
 * Returns a callback to remove a filter item by id.
 * It looks for an input element with the given id,
 * unchecks it and triggers a change event for that input.
 * @param {Element} component
 * @param {jQuery} $itemTemplate
 * @returns {Function} A callback function
 */
const handleItemRemove = (component, $itemTemplate) => (e) => {
    const id = $(e.target).attr('data-id');

    $(component)
        .find(`fieldset[name="${id}"] input`)
        .prop('checked', false)
        .removeAttr('checked'); // fix for initially checked input markup

    $(e.target).remove();
    $(component).attr('data-index', 0);
    handleLoad(component, $itemTemplate)();
};

export default handleItemRemove;



// WEBPACK FOOTER //
// ./src/scripts/components/references/handleItemRemove.js